/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Pass_Iap_1_Time_FootnoteInputs */

const en_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time purchase for the VIP rewards of this event.`)
};

const ar_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عملية شراء لمرة واحدة للحصول على مكافآت كبار الشخصيات لهذا الحدث.`)
};

const de_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmaliger Kauf für die VIP-Prämien dieser Veranstaltung.`)
};

const es_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra única para obtener las recompensas VIP de este evento.`)
};

const fr_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achat unique pour accéder aux récompenses VIP de cet événement.`)
};

const it_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisto una tantum per i premi VIP di questo evento.`)
};

const ja_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このイベントのVIP報酬は、1回の購入でアンロックできます。`)
};

const ko_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이번 이벤트의 VIP 리워드에 대한 일회성 구매입니다.`)
};

const pt_br_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma única compra para as recompensas VIP deste evento.`)
};

const ru_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Единовременная покупка для получения VIP-наград этого события.`)
};

const th_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อครั้งเดียวเพื่อรับรางวัล VIP ของอีเวนต์นี้`)
};

const tr_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu etkinliğin VIP ödülleri için tek seferlik satın alma.`)
};

const zh_cn_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单次购买本次活动 VIP 奖励领取资格`)
};

const zh_tw_focus_pass_iap_1_time_footnote = /** @type {(inputs: Focus_Pass_Iap_1_Time_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`單次購買本活動 VIP 獎勵領取資格`)
};

/**
* | output |
* | --- |
* | "One-time purchase for the VIP rewards of this event." |
*
* @param {Focus_Pass_Iap_1_Time_FootnoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_iap_1_time_footnote = /** @type {((inputs?: Focus_Pass_Iap_1_Time_FootnoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Iap_1_Time_FootnoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "ar") return ar_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "de") return de_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "es") return es_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "fr") return fr_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "it") return it_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "ja") return ja_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "ko") return ko_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "ru") return ru_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "th") return th_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "tr") return tr_focus_pass_iap_1_time_footnote(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_iap_1_time_footnote(inputs)
	return zh_tw_focus_pass_iap_1_time_footnote(inputs)
});